import React, { ReactNode } from 'react';
import { usePermissionChecker } from '@utils/permissionChecker';
import PermissionDenied from './PermissionDenied';
import Loader from './Loader';

interface ProtectedComponentProps {
    requiredPermission: string;
    children: ReactNode;
}

const ProtectedComponent: React.FC<ProtectedComponentProps> = ({
    requiredPermission,
    children,
}) => {
    const { hasPermission, loading } = usePermissionChecker(requiredPermission);

    if (loading) {
        return <Loader />;
    }

    if (!hasPermission) {
        return <PermissionDenied />;
    }

    return <>{children}</>;
};

export default ProtectedComponent;
